import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import {SiLeetcode} from 'react-icons/si'
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";

const SocialLinks = () => {
  const links = [
    {
      id: 1,
      child: (
        <>
          Linkedin
          <FaLinkedin size={30} />
        </>
      ),
      href:'https://in.linkedin.com/in/sagar-gupta-8b2660172',
      style: 'rounded-tr-md'
    },
    {
        id: 2,
        child: (
          <>
            GitHub
            <FaGithub size={30} />
          </>
        ),
        href:'https://github.com/HeyitzSagar',
      }, {
        id: 3,
        child: (
          <>
            Mail
            <HiOutlineMail size={30} />
          </>
        ),
        href:'mailto:sagargupta.gola@gmail.com',
      }, {
        id: 4,
        child: (
          <>
            Resume
            <BsFillPersonLinesFill size={30} />
          </>
        ),
        href:'/resume.pdf',
        download: true,
      }, {
        id: 6,
        child: (
          <>
            LeetCode
            <SiLeetcode size={30} />
          </>
        ),
        href:'https://leetcode.com/hereissagar/',
        style: 'rounded-br-md',
      },
  ];
  return (
    <div className="hidden lg:flex flex-col top-[35%] left-0 fixed">
      <ul>
        {links.map(({id, child, href, style, download})=>(
            <li key={id}
            className={"flex justify-between items-center w-40 h-10 px-4 bg-gray-500 ml-[-110px] hover:rounded-md duration-300 hover:ml-[-10px] " + 
            " " 
            + style}>
            <a
              href={href}
              className="flex justify-between items-cente w-full text-white"
              download={download}
              target='_blank'
              rel="noreferrer"
            >
             {child}
            </a>
          </li>
        ))} 
        
      </ul>
    </div>
  );
};

export default SocialLinks;
